import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/article

export const Article = styled.article`
  display: flex;
`;
